<!-- 订单详情 -->
<template>
  <div class="orderdetail">
    <el-page-header class="page-header" @back="goBack" content="订单详情">
    </el-page-header>
    <div class="main">
      <div class="step shadow-grid" v-if="steps.length">
        <el-steps :active="DATA.orderStatus+1" finish-status="success">
          <el-step
            v-for="step in steps"
            :title="step.title"
            :description="step.time"
            :key="step.id"
          ></el-step>
        </el-steps>
      </div>
      <div class="desc shadow-grid">
        <div class="desc-l desc-grid">
          <div class="desc-grid-head">配送信息</div>
          <div class="desc-grid-cell">
            配送方式: {{ DATA.deliveryTypeName }}
          </div>
          <div v-if="DATA.expectDeliveryTime" class="desc-grid-cell">
            配送时间: {{ DATA.expectDeliveryTime }}
          </div>
          <div
            v-if="
              DATA.receiverName || DATA.receiverMobile || DATA.receiverAddress
            "
            class="desc-grid-cell"
          >
            收货信息:
            <template>
              {{ DATA.receiverName }}
            </template>
            <template>
              {{ DATA.receiverMobile }}
            </template>
            <template>
              {{ DATA.receiverAddress }}
            </template>
          </div>
          <div class="desc-grid-cell">买家昵称: {{ DATA.userNickname }}</div>
        </div>
        <div class="desc-r desc-grid">
          <div class="desc-grid-head">订单状态: {{ DATA.orderStatusName }}</div>
        </div>
      </div>
      <div class="desc shadow-grid">
        <div class="desc-l desc-grid">
          <div class="desc-grid-head">订单信息</div>
          <div class="desc-grid-cell">订单编号: {{ DATA.orderNo }}</div>
          <div class="desc-grid-cell">渠道类型: {{ DATA.channelTypeName }}</div>
          <div class="desc-grid-cell">订单来源: {{ DATA.orderSourceName }}</div>
          <div class="desc-grid-cell">销售门店: {{ DATA.storeTitle }}</div>
        </div>
        <div class="desc-r desc-grid">
          <div class="desc-grid-head"></div>
          <div class="desc-grid-cell">
            支付方式: {{ `${DATA.paymentTypeName}` }}
          </div>
          <div class="desc-grid-cell">
            服务门店: {{ DATA.processStoreTitle }}
          </div>
        </div>
      </div>
      <div class="table">
        <el-table :data="DATA.itemList" style="width: 100%">
          <el-table-column prop="title" label="商品" min-width="200">
            <template slot-scope="scope">
              <div v-if="!scope.row.other" class="scope-title">
                <el-image
                  class="scope-title-img"
                  style="width: 6.0rem; height: 6.0rem; border-radius: 4px"
                  :src="scope.row.imageUrl"
                  :preview-src-list="[scope.row.imageUrl]"
                ></el-image>
                <div class="scope-title-text">
                  <p
                    class="scope-title-text-head"
                    :title="scope.row.goodsTitle"
                  >
                    {{ scope.row.goodsTitle }}
                  </p>
                  <p class="scope-title-text-row">
                    数量：{{ scope.row.skuNum }}
                  </p>
                  <p class="scope-title-text-row">
                    单价：¥{{ scope.row.price }}
                  </p>
                  <p class="scope-title-text-row">
                    仓库：{{ scope.row.warehouseName }}
                  </p>
                </div>
              </div>
              <div v-else>
                <p class="bold">{{ scope.row.title }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="totalAmount"
            label="小计（元）"
            min-width="180"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.title == '优惠信息'">
                <span
                  style="display: inline-flex; margin-left: 4px"
                  v-for="(item, index) in scope.row.DiscountAmount"
                  :key="index"
                >
                  {{ item }}
                </span>
              </div>
              <div v-else>
                {{ scope.row.totalAmount }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="优惠减免金额（元）" min-width="160">
            <template slot-scope="scope">
              <template v-if="!scope.row.other">
                <template
                  v-if="
                    scope.row.goodsDiscountInfo.couponDiscountAmount ||
                    scope.row.goodsDiscountInfo.couponCodeDiscountAmount
                  "
                >
                  <p v-if="scope.row.goodsDiscountInfo.couponDiscountAmount">
                    {{
                      `【优惠券】¥${scope.row.goodsDiscountInfo.couponDiscountAmount}`
                    }}
                  </p>
                  <p
                    v-if="scope.row.goodsDiscountInfo.couponCodeDiscountAmount"
                  >
                    {{
                      `【优惠码】¥${scope.row.goodsDiscountInfo.couponCodeDiscountAmount}`
                    }}
                  </p>
                </template>
                <p v-else>0</p>
              </template>
              <template v-else>
                <template>
                  <div
                    v-for="(item, index) in scope.row.couponAmount"
                    :key="index"
                  >
                    {{ item }}
                  </div>
                </template>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="shouldPaymentAmount" label="应收金额（元）">
            <template slot-scope="scope">
              <template v-if="!scope.row.other">
                <div>
                  <p v-if="scope.row.shouldPaymentAmount">
                    {{ scope.row.shouldPaymentAmount }}
                  </p>
                  <p v-else>0</p>
                </div>
              </template>
              <template v-else>
                <div v-if="scope.row.shouldPaymentAmount">
                  <p>
                    {{ scope.row.shouldPaymentAmount }}
                  </p>
                </div>
                <div v-else></div>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="优惠抵扣（元）" min-width="160">
            <template slot-scope="scope">
              <template v-if="!scope.row.other">
                <template
                  v-if="
                    scope.row.goodsDiscountInfo.promotionDiscountAmount ||
                    scope.row.goodsDiscountInfo.membershipDiscountAmount ||
                    scope.row.goodsDiscountInfo.memberPointsDiscountAmount ||
                    scope.row.goodsDiscountInfo.balanceDiscountAmount ||
                    scope.row.goodsDiscountInfo.nynjDiscountAmount
                  "
                >
                  <p v-if="scope.row.promotionDiscountAmount">
                    {{
                      `【满减满折】¥${scope.row.goodsDiscountInfo.promotionDiscountAmount}`
                    }}
                  </p>
                  <p
                    v-if="scope.row.goodsDiscountInfo.membershipDiscountAmount"
                  >
                    {{
                      `【会员折扣】¥${scope.row.goodsDiscountInfo.membershipDiscountAmount}`
                    }}
                  </p>
                  <p
                    v-if="
                      scope.row.goodsDiscountInfo.memberPointsDiscountAmount
                    "
                  >
                    {{
                      `【积分抵扣】¥${scope.row.goodsDiscountInfo.memberPointsDiscountAmount}`
                    }}
                  </p>
                  <p v-if="scope.row.goodsDiscountInfo.balanceDiscountAmount">
                    {{
                      `【余额抵扣】¥${scope.row.goodsDiscountInfo.balanceDiscountAmount}`
                    }}
                  </p>
                  <p v-if="scope.row.goodsDiscountInfo.nynjDiscountAmount">
                    {{
                      `【N元N件抵扣】¥${scope.row.goodsDiscountInfo.nynjDiscountAmount}`
                    }}
                  </p>
                </template>
                <p v-else>0</p>
              </template>
              <template v-else>
                <template v-if="scope.row.title !== '优惠信息'">
                  <div
                    v-for="(item, index) in scope.row.DiscountAmount"
                    :key="index"
                  >
                    {{ item }}
                  </div>
                </template>
              </template>
            </template>
          </el-table-column>
          <el-table-column
            prop="merchantDiscountAmount"
            label="加价/减价（元）"
          >
            <template slot-scope="scope">
              <template v-if="!scope.row.other">
                <div>
                  <p v-if="scope.row.merchantDiscountAmount"></p>
                  <p v-else>0</p>
                </div>
              </template>
              <template v-else>
                <div></div>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="paymentAmount" label="实收金额(元)">
            <template slot-scope="scope">
              <div
                :class="{
                  'm-red': scope.row.title == '总计',
                }"
              >
                {{ scope.row.paymentAmount }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from "./mixins/wm.js";
export default {
  name: "orderdetail",
  components: {},
  mixins: [auth],
  data() {
    return {
      DATA: {},
      steps: [],
    };
  },

  computed: {},

  mounted() {
    this.getList();
  },

  methods: {
    goBack() {
      this.$router.back();
    },
    async getList() {
      const { data: res } = await this.axios({
        url: "weimob/mc/order/returnOrderList",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          id: this.$route.query.id,
        }),
      });
      const { data: detail } = await this.axios({
        url: "weimob/mc/order/queryOrderDetail",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          orderNo: this.$route.query.orderNo,
        }),
      });
      if (detail.code == 0) {
        this.$message.error(detail.msg);
      }
      if (res.code == 1) {
        const detailData = detail.data;
        const d = Object.assign(res.data.data[0], {
          itemList: detailData.itemList,
          shouldPaymentAmount: detailData.shouldPaymentAmount,
          totalAmount: detailData.totalAmount,
          shouldPaymentAmount: detailData.shouldPaymentAmount,
          discountInfo: detailData.discountInfo,
          cancelTime: detailData.cancelTime,
          finishTime: detailData.cancelTime,
          deliveryTime: detailData.deliveryTime,
        });

        // 步骤条
        let steps = [];
        steps = [
          {
            id: 1,
            title: "买家下单",
            time: d.createTime,
          },
          {
            id: 2,
            title: "买家付款",
            time: d.paymentTime,
          },
          {
            id: 3,
            title: "商家发货",
            time: d.deliveryTime,
          },
          {
            id: 4,
            title: "交易完成",
            time: d.finishTime,
          },
          {
            id: 5,
            title: "已评论",
            time: "",
          },
        ];
        
        // 已取消
        if (d.orderStatus == 4) {
          steps = [
            {
              id: 1,
              title: "买家下单",
              time: d.createTime,
            },
            {
              id: 2,
              title: "买家付款",
              time: d.paymentTime,
            },
            {
              id: 4,
              title: "交易取消",
              time: d.cancelTime,
            },
          ];
        }
        this.steps = steps;

        // 订单总计的优惠金额
        // 订单优惠金额
        let couponAmount = 0;
        // 优惠券优惠金额
        if (d.discountInfo.couponDiscountAmount) {
          couponAmount += d.discountInfo.couponDiscountAmount;
        }
        // 码券优惠金额
        if (d.discountInfo.couponCodeDiscountAmount) {
          couponAmount += d.discountInfo.couponCodeDiscountAmount;
        }

        const commonDiscountInfo = d.discountInfo.commonDiscountInfo;

        // 订单折扣金额
        let DiscountAmount = 0;
        // 满减满折金额
        if (d.discountInfo.promotionDiscountAmount) {
          DiscountAmount += d.discountInfo.promotionDiscountAmount;
        }
        // 会员折扣金额
        if (d.discountInfo.membershipDiscountAmount) {
          DiscountAmount += d.discountInfo.membershipDiscountAmount;
        }
        // 余额抵扣金额
        if (d.discountInfo.balanceDiscountAmount) {
          DiscountAmount += d.discountInfo.balanceDiscountAmount;
        }

        // 优惠信息的展示
        // 订单优惠金额
        let couponAmountDiscount = [];
        // 优惠券优惠金额
        if (d.discountInfo.couponDiscountAmount) {
          couponAmountDiscount.push(
            `【优惠券优惠】¥${d.discountInfo.couponDiscountAmount}`
          );
        }
        // 码券优惠金额
        if (d.discountInfo.couponCodeDiscountAmount) {
          couponAmountDiscount.push(
            `【码券优惠】¥${d.discountInfo.couponCodeDiscountAmount}`
          );
        }

        // 订单折扣金额
        let DiscountAmountDiscount = [];
        // 满减满折金额
        if (d.discountInfo.promotionDiscountAmount) {
          DiscountAmountDiscount.push(
            `【满减满折】¥${d.discountInfo.promotionDiscountAmount}`
          );
        }
        // 会员折扣金额
        if (d.discountInfo.membershipDiscountAmount) {
          DiscountAmountDiscount.push(
            `【会员折扣】¥${d.discountInfo.membershipDiscountAmount}`
          );
        }
        // 余额抵扣金额
        if (d.discountInfo.balanceDiscountAmount) {
          DiscountAmountDiscount.push(
            `【余额抵扣】¥${d.discountInfo.balanceDiscountAmount}`
          );
        }

        // 运费抵扣金额
        const DeliveryAmount = [];
        if (d.discountInfo.pointsDiscountDeliveryAmount) {
          DeliveryAmount.push(
            `【积分抵扣】¥${d.discountInfo.pointsDiscountDeliveryAmount}`
          );
        }
        if (d.discountInfo.balanceDiscountDeliveryAmount) {
          DeliveryAmount.push(
            `【余额抵扣】¥${d.discountInfo.balanceDiscountDeliveryAmount}`
          );
        }

        // 通用折扣
        const DeliveryCouponAmount = [];
        for (let index = 0; index < commonDiscountInfo.length; index++) {
          const element = commonDiscountInfo[index];
          if (element.discountObjectType == 2) {
            couponAmount += element.discountAmount;
          } else if (element.discountObjectType == 1) {
            // 运费
            DeliveryCouponAmount.push(
              `【${element.name}】-¥${element.discountAmount}`
            );
            // 优惠信息
            DiscountAmountDiscount.push(
              `【${element.name}】-¥${element.discountAmount}`
            );
          }
        }
        d.itemList.push(
          {
            other: true,
            title: "运费",
            totalAmount: d.deliveryAmount,
            couponAmount: DeliveryCouponAmount,
            shouldPaymentAmount: d.discountInfo.balanceDiscountDeliveryAmount,
            DiscountAmount: DeliveryAmount,
            paymentAmount: d.deliveryPaymentAmount,
          },
          {
            other: true,
            title: "优惠信息",
            totalAmount: "",
            paymentAmount: "",
            shouldPaymentAmount: "",
            merchantDiscountAmount: "",
            couponAmount: couponAmountDiscount,
            DiscountAmount: DiscountAmountDiscount,
          },

          {
            other: true,
            title: "总计",
            totalAmount: d.totalAmount,
            couponAmount: [couponAmount],
            DiscountAmount: [DiscountAmount],
            shouldPaymentAmount: d.shouldPaymentAmount,
            merchantDiscountAmount: d.discountInfo.merchantDiscountAmount,
            paymentAmount: d.paymentAmount,
          }
        );
        this.DATA = res.data.data[0];
      }
    },
  },
};
</script>
<style lang="scss"  scoped>
::v-deep .el-table th,
.el-table tr {
  background-color: #fff;
  color: #000;
}
.bold {
  font-weight: bold;
}
.shadow-grid {
  box-shadow: 0 0 4px 0 rgb(131 131 131 / 40%);
  border-radius: 5px;
  padding: 2.0rem;
}

.desc {
  margin-top: 2.0rem;
  display: flex;
  line-height: 1.425;
  color: #595961;
  &-grid {
    width: 50%;
    &-head {
      font-size: 14px;
      padding: 1.0rem 0;
      font-weight: bold;
    }
    &-cell {
      font-size: 12px;
      padding: 4px 0;
    }
  }
}

.table {
  margin-top: 2.0rem;
}

// 商品信息
.scope-title {
  display: flex;
  &-img {
    width: 36px;
  }
  &-text {
    flex: 1;
    margin-left: 8px;
    &-row {
      color: #666;
      font-size: 12px;
      word-break: break-all;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      cursor: pointer;
    }
    &-head {
      font-weight: 600;
    }
  }
}
.m-red {
  color: #ff5050;
}

::v-deep .el-table tr:last-child {
  font-weight: bold;
}
</style>